import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import { NotiDetailModel } from 'models/notiModel';

interface MsgDetailProps {
    data: NotiDetailModel;
    onClose: () => void;
}

export const MsgDetail = (props: MsgDetailProps) => {
    const { data, onClose } = props;

    return (
        <div className={styles.popupWrap}>
            <img className={styles.titleImg} src={require('assets/images/icons/home/home-popup-title.png')} alt="THÔNG BÁO" />

            <span className={styles.closeIcon} onClick={onClose} role="button" aria-label="close" />

            <div className={styles.contentOuter}>
                <div className={styles.contentScroll}>
                    {data.photourl !== null && data.photourl !== '' && <img className={styles.photo} src={data.photourl} alt="" />}
                    <div className={styles.htmlContent} dangerouslySetInnerHTML={{ __html: data.content }} />
                </div>
            </div>
        </div>
    );
};

const styles = {
    popupWrap: css`
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-font-smoothing: antialiased;

        font-family: 'UTM Avo', sans-serif;
        font-weight: bold;
        line-height: 1.2;
        font-size: 14px;
        color: #282c35;

        box-sizing: border-box;
        margin: 0;
        margin-top: 10px;

        background-image: linear-gradient(to bottom, ${colors.primary}, #2c5490, ${colors.primary});
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;

        border: 1px solid #dec887;
        padding: 10px;
        padding-top: 100px;

        transition: all 400ms ease-in-out;
        position: relative;
        opacity: 1;
    `,

    titleImg: css`
        position: absolute;
        top: -10px;
        left: 50%;
        transform: translateX(-50%);
        height: 72px;
        width: auto;
        user-select: none;
        pointer-events: none;
        z-index: 2;
    `,

    closeIcon: css`
        position: absolute;
        top: 14px;
        right: 14px;
        width: 34px;
        height: 34px;
        cursor: pointer;

        &:before,
        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 22px;
            height: 2px;
            background: rgba(255, 255, 255, 0.7);
            transform-origin: center;
        }
        &:before {
            transform: translate(-50%, -50%) rotate(45deg);
        }
        &:after {
            transform: translate(-50%, -50%) rotate(-45deg);
        }

        &:hover:before,
        &:hover:after {
            background: rgba(255, 255, 255, 0.95);
        }
    `,

    contentOuter: css`
        height: calc(620px - 100px - 70px);
        background: #ffffff;
        border: 1px solid #dec887;
        border-radius: 4px;
        padding: 10px 12px;
        box-sizing: border-box;
    `,

    contentScroll: css`
        height: 100%;
        overflow: auto;

        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.25) transparent;

        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.25);
            border-radius: 8px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
    `,

    titleText: css`
        margin: 0 0 12px 0;
        font-size: 18px;
        color: ${colors.primary};
        font-weight: 700;
    `,

    photo: css`
        width: 100%;
        display: block;
        margin: 0 0 10px 0;
        border-radius: 4px;
    `,

    htmlContent: css`
        font-weight: 400;
        line-height: 1.45;
        color: #111;

        p,
        span,
        font,
        div,
        li {
            line-height: 1.45;
        }

        img {
            max-width: 100%;
            height: auto;
        }

        a {
            color: #0b59d6;
            word-break: break-word;
        }
    `,

    wrapClose: css`
        text-align: center;
        margin-top: 12px;

        button {
            width: 180px;
            border-radius: 8px;
            padding: 8px 12px;
        }
    `,
};
